import { request } from "@lib/http";
import { saveState, loadState } from "@lib/localStorage";


export async function getToken() {
    return loadState("user-access-token")
};
export async function dataList() {
    try {
        const response = await request('get', `/data_lists`, {});
        if (response.success) return response.data;
        
    } catch (err) {
        console.log('Operation failed', err);
        return false;
    }
};